<script setup lang="ts">
import ActionButtonComponent, {ActionButtonProps as ActionButton} from "./ActionButtonComponent.vue"
import {defineEmits} from "vue";

const emit = defineEmits(["toggle"])
let buttons: ActionButton[] = [
    {
        label: "Cancel",
        styleType: "optional",
        onclick: () => {emit('toggle')}
    } as ActionButton,
    {
        label: "Login",
        styleType: "primary",
        onclick: () => {window.location.href = `/account/signin/?return_to=${encodeURIComponent(window.location.href)}`}
    } as ActionButton,
]

</script>

<template>
    <div class="fixed inset-0 z-[999] grid h-screen w-screen place-items-center">
        <div class="bg-mono-ns-100 rounded-3xl w-[295px] xl:w-[569px] flex flex-col p-2 xl:p-4 font-sans">
            <button type="button" class="p-2.5 self-end text-mono-ps-200" @click="emit('toggle')">
                <svg class="w-6 h-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.5 3.5C20.1 3.1 19.5 3.1 19.1 3.5L12 10.6L4.9 3.5C4.5 3.1 3.9 3.1 3.5 3.5C3.1 3.9 3.1 4.5 3.5 4.9L10.6 12L3.5 19.1C3.1 19.5 3.1 20.1 3.5 20.5C3.9 20.9 4.5 20.9 4.9 20.5L12 13.4L19.1 20.5C19.5 20.9 20.1 20.9 20.5 20.5C20.9 20.1 20.9 19.5 20.5 19.1L13.4 12L20.5 4.9C20.9 4.5 20.9 3.9 20.5 3.5Z" fill="currentColor"></path>
                </svg>
            </button>
            <div class="flex flex-col xl:flex-row gap-4 xl:gap-6 mb-6 items-center xl:items-start px-2 xl:px-4">

                <svg class="w-16 h-16 p-3 rounded-full xl:w-[72px] xl:h-[72px] text-mono-ns-100 bg-red-light" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M29.3332 16C29.3332 8.66667 23.3332 2.66669 15.9999 2.66669C8.66661 2.66669 2.66663 8.66667 2.66663 16C2.66663 23.3729 8.75472 29.3333 15.9999 29.3333C23.1798 29.3333 29.3332 23.2496 29.3332 16ZM5.33329 16C5.33329 10.1333 10.1333 5.33335 15.9999 5.33335C21.8666 5.33335 26.6666 10.1333 26.6666 16C26.6666 18.6666 25.5999 21.2 23.9999 23.0666V22.6666C23.9999 21.2 22.7999 20 21.3332 20H10.6666C9.19994 20 7.99995 21.2 7.99995 22.6666V23.0666C6.39995 21.2 5.33329 18.6666 5.33329 16Z" fill="currentColor"/>
                    <path d="M15.9999 18.6666C18.9455 18.6666 21.3333 16.2788 21.3333 13.3333C21.3333 10.3878 18.9455 8 15.9999 8C13.0544 8 10.6666 10.3878 10.6666 13.3333C10.6666 16.2788 13.0544 18.6666 15.9999 18.6666Z" fill="currentColor"/>
                </svg>


                <div class="flex flex-col gap-6  px-2 xl:px-4">
                    <h3 class="text-h3m xl:text-h3 font-bold text-mono-white text-center xl:text-left">Log In</h3>
                    <p class="text-p5m xl:text-smm text-mono-ps-100">Please log in to Rate.</p>
                </div>
            </div>
            <div class="btn-wrapper flex flex-col xl:flex-row gap-4 xl:gap-6 items-center mb-8 xl:mb-6 pt-4 xl:pt-6 px-2 xl:px-4">
                <ActionButtonComponent
                    v-for="button in buttons"
                    :key="button.label"
                    :label="button.label"
                    :icon="button?.icon"
                    :spinner="button?.spinner"
                    :styleType="button.styleType"
                    :onclick="button?.onclick"></ActionButtonComponent>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
